import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

const StorePlaceholder = () => {
  return (
    <Dimmer active inverted>
      <Loader inverted />
    </Dimmer>
  )
}

export default StorePlaceholder



// WEBPACK FOOTER //
// ./src/components/restaurants/views/storePlaceholder.js